import React from "react";
import "./navbar.css";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../../img/logo.jpg";

const Navbarr = () => {
  return (
    <Navbar bg="light" className=" shadow-navbar nav" data-bs-theme="light">
      <Container>
        <Navbar.Brand href="#home">
          <img
            src={logo}
            alt="Logo"
            width="30"
            height="30"
            className="d-inline-block align-top edulogo"
          />
        </Navbar.Brand>
        <Nav className="ms-auto links">
          <Nav.Link href="#home">Home</Nav.Link>
          <Nav.Link
            href="https://staff.edu-central.org/login?origin=/dashboard/
          "
            target="_blank"
          >
            Dashboard
          </Nav.Link>
          <Nav.Link href="https://edu-central.org/" target="_blank">
            About Us
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default Navbarr;
